export default __webpack_public_path__ + "static/media/landing_slide1.2693ec77.png";